<template>
  <div>
    <STable
      ref="tableref"
      :url="url"
      :columns="columns"
      :selection="false"
      :loading="false"
      label-width="100px"
    />
  </div>
</template>

<script>
export default {
  props: {
    delay: {
      type: Number,
      default() {
        return 5000;
      },
    },
    orderNum: {
      type: String,
      default() {
        return "";
      },
    },
  },
  data() {
    return {
      timer: "",
      id: "",
      url: "/logs/logs/page?msgType=17",
      columns: [
        {
          label: "上送时间",
          prop: "time",
        },
        {
          label: "充电电量（度）",
          prop: "chargeDegrees",
        },
        {
          label: "充电时长（分钟）",
          prop: "chargeTimes",
        },
        {
          label: "当前SOC",
          prop: "soc",
          // template: (index, reocrd) => {
          //   return reocrd.SOC?parseFloat(reocrd.SOC)+'%':'--'
          // }
        },
        {
          label: "已充金额（元）",
          prop: "chargeAmounts",
        },
        {
          label: "电压（V）",
          prop: "voltage",
        },
        {
          label: "电流（A）",
          prop: "electric",
        },
        {
          label: "枪线温度（℃）",
          prop: "gunLineTemp",
        },
        {
          label: "电池温度（℃）",
          prop: "batteryTemp",
        },
      ],
    };
  },

  beforeMount() {
    this.url =
      "/msglog/messageLog/realTimeDataList?startChargeSeq=" +
      this.$route.query.num;
  },
  mounted() {
    this.$nextTick(() => {
      if (this.delay) {
        this.timer = setInterval(() => {
          this.$refs.tableref.queryTable();
        }, this.delay);
      }
    });
  },
  // 页面销毁时清除定时器
  beforeDestroy() {
    clearInterval(this.timer);
  },
  methods: {},
};
</script>

<style scpoed lang="less">
</style>



// WEBPACK FOOTER //
// src/views/orderManagement/components/real-time-list.vue